<template>
  <div class="container">
    <header class="production-header">
      <p class="header-titkle">学生作品</p>
      <router-link :to="{ name: 'my_student_production_add' }">
        <el-button size="mini">上传学生作品</el-button>
      </router-link>
    </header>
    <div class="production-body">
      <div
        class="temporary_show-container"
        v-loading="loading"
        element-loading-spinner="el-icon-loading"
        v-if="!studentWorkData.length"
      >
        暂无数据
      </div>
      <div class="production-list">
        <div
          class="production-item"
          v-for="(item, index) in studentWorkData"
          :key="item.id"
        >
          <div class="production-item-content">
            <img
              :src="(item.file || {}).file_src"
              class="img"
              v-if="item.file"
            />
            <p class="no-img" v-else>暂未上传封面</p>
            <p class="title">{{ item.poetry_name }}</p>
            <p class="desc">
              作者/教师：{{ item.author }}({{ item.teacher_name }})
            </p>
            <div class="content">
              <p class="content-text" v-html="item.poetry_content"></p>
            </div>
          </div>
          <div class="handle">
            <div class="handle-click">
              <router-link
                :to="{
                  name: 'my_student_production_edit',
                  params: { id: item.id }
                }"
              >
                <el-button plain size="mini" class="edit-button"
                  >编辑</el-button
                >
              </router-link>
              <el-button
                style="margin-left: 8px"
                type="danger"
                size="mini"
                @click="handleDelete(item.id, index)"
                >删除</el-button
              >
            </div>
            <p class="production-item-hint">{{ item.status_label }}</p>
          </div>
        </div>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="pageSize"
        :current-page="currentPage"
        :total="total"
        @current-change="editCurrentPage"
        :hide-on-single-page="true"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import userService from "@/global/service/user";
export default {
  data() {
    return {
      studentWorkData: [],
      pageSize: 10,
      total: null,
      currentPage: 1,
      loading: true
    };
  },
  created() {
    this.getData();
  },
  methods: {
    editCurrentPage(index) {
      this.currentPage = index;
      this.getData();
    },
    getData() {
      const params = {
        page: this.currentPage,
        page_size: this.pageSize
      };
      userService
        .studentWork(params)
        .then(res => {
          this.studentWorkData = res.list;
          this.currentPage = res.pagination.current_page;
          this.total = res.pagination.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleDelete(id, index) {
      this.$confirm("确认删除?")
        .then(() => {
          userService.studentWorkDelete(id).then(() => {
            this.$message.success("删除成功");
            this.studentWorkData.splice(index, 1);
          });
        })
        .catch(() => {});
    }
  }
};
</script>
<style lang="less" scoped>
.production-header {
  display: flex;
  justify-content: space-between;
  padding: 10px 15px;
  align-items: center;
  background-color: #fff;
  font-size: 12px;
  border-radius: 5px;
}
.production-body {
  display: flex;
  flex-direction: column;

  .production-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 20px 0;
    .production-item {
      background-color: #fff;
      width: 48%;
      margin-bottom: 30px;
      display: flex;
      flex-direction: column;
      .production-item-content {
        flex: 1;
      }
      .img {
        width: 100%;
        height: calc(100vh / 2.6);
        object-fit: cover;
      }
      .no-img {
        width: 100%;
        height: calc(100vh / 2.6);
        font-size: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #999;
      }
      .title {
        display: block;
        padding: 10px;
        font-size: 15px;
        line-height: 18px;
        font-weight: 600;
        text-align: left;
        border-bottom: 1px solid #dedede;
      }
      .desc {
        font-size: 14px;
        line-height: 40px;
        display: block;
        text-align: left;
        padding-left: 10px;
      }
      .content {
        padding: 5px 10px;
        overflow: hidden;
        .content-text {
          font-size: 12px;
          line-height: 20px;
          color: #999;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
      }
      .handle {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
        .production-item-hint {
          color: #666;
          font-size: 14px;
          font-weight: 400;
        }
      }
    }
  }
}
.edit-button {
  color: #ff9900;
  border-color: #ff9900;
  transition: all 0.2s;
  &:hover {
    color: #fff;
    background: #ff9900;
  }
}
</style>
